var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 18 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "priceIcon",
    transform: "translate(-238.676 12.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M246.728,5.713h-.387A2.164,2.164,0,0,1,245.2,5c-.638-.654-1.29-1.294-1.935-1.94q-2.044-2.043-4.086-4.088a1.5,1.5,0,0,1-.026-2.221q4.237-4.248,8.486-8.483a1.856,1.856,0,0,1,1.329-.553c2.055-.009,4.111-.006,6.166,0a1.42,1.42,0,0,1,1.246.631,3.848,3.848,0,0,1,.294.7V-4.34a.269.269,0,0,0-.031.059,2.318,2.318,0,0,1-.632,1.149Q251.929.94,247.856,5.023A2.127,2.127,0,0,1,246.728,5.713Zm6.946-13.474A1.508,1.508,0,0,0,252.2-9.283a1.493,1.493,0,0,0-1.519,1.473,1.489,1.489,0,0,0,1.47,1.522A1.511,1.511,0,0,0,253.674-7.761Z",
    transform: "translate(0 0)",
    fill: "#7462bc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceIcon);
export default __webpack_public_path__ + "static/media/priceIcon.112ffe119b097d3cc0c76707b006b6a9.svg";
export { ForwardRef as ReactComponent };